import {Injectable} from '@angular/core';
import {PaginatorService} from "@shared/api/services/paginator.service";
import {RecordModalityOfTherapy} from "@shared/api/models/query/patient-record-appointment-note.model";

@Injectable({
    providedIn: 'root'
})
export class RecordModalityOfTherapyService extends PaginatorService<RecordModalityOfTherapy> {

    protected override get domainEntity() {
        return 'lists/record-modalities-of-therapy';
    };
}
